module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../style-loader/index.js!../../css-loader/index.js?sourceMap!../../postcss-loader/index.js!./solarized-light.css"));
	});
}


//////////////////
// WEBPACK FOOTER
// ./~/bundle-loader?lazy!./~/highlight.js/styles/solarized-light.css
// module id = 72742107
// module chunks = 28 36